var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '../../../store';
const interimTextSelector = createSelector(_react_refresh_temp_1 = (state) => state.speechServices, (speechServices) => speechServices.interimText);
$RefreshReg$(_react_refresh_temp_1, "interimTextSelector$createSelector");
const InterimTextElms = () => {
    _react_refresh_temp_3();
    const interimText = useAppSelector(interimTextSelector);
    const scrollToRef = useRef(null);
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (scrollToRef.current) {
                scrollToRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                });
            }
        }, 500);
        return () => {
            clearTimeout(timeout);
        };
    }, [interimText]);
    return (_jsxs(_Fragment, { children: [interimText ? (_jsxs("div", { className: "sentence w-full pt-2", children: [_jsxs("p", { className: "date text-sm pb-1 primaryColor dark:text-darkText", children: [_jsx("span", { className: "text-xs", children: interimText.time }), ' ', interimText.from, ":"] }), _jsx("p", { className: "message-content max-w-fit shadow-footer text-sm bg-secondaryColor text-white py-1 px-2 rounded", children: interimText.text })] })) : null, _jsx("div", { className: "pt-[5px]", ref: scrollToRef })] }));
};
_react_refresh_temp_2 = InterimTextElms;
$RefreshReg$(_react_refresh_temp_2, "InterimTextElms");
_react_refresh_temp_3(InterimTextElms, "V+46+51jwqfRMTwlNeskdt5pTYI=", false, () => [useAppSelector]);
export default InterimTextElms;
